// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chevron-down.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/chevron-down'

import { Icon, type IconComponentProps } from '../icon'

export const ChevronDownIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
